const getFromUrl = (param) => {

    const urlSearchString = window.location.search;
    const params = new URLSearchParams(urlSearchString);
    return params.get(param);

}

export default getFromUrl;
